import { RootState } from 'reducers/store'

export const getSectionInfo = (state: Pick<RootState, 'tracking'>) => {
  return state.tracking.section.value
}
export const getActivePageInfo = (state: Pick<RootState, 'tracking'>) => {
  return state.tracking.activepage.value
}
